import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { EvaluationProvider } from "./contexts/EvaluationContext";
import { useLanguageRedirect } from "./hooks/useLanguageRedirect";
import Index from "./pages/Index";
import Camera from "./pages/Camera";
import Result from "./pages/Result";
import Quiz from "./pages/Quiz";
import Trends from "./pages/Trends";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import History from "./pages/History";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCanceled from "./pages/PaymentCanceled";
import NotFound from "./pages/NotFound";
import './i18n/config';

const queryClient = new QueryClient();

const App = () => {
  useLanguageRedirect();
  
  return (
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <EvaluationProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/camera" element={<Camera />} />
              <Route path="/result" element={<Result />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/trends" element={<Trends />} />
              <Route path="/history" element={<History />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-canceled" element={<PaymentCanceled />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </TooltipProvider>
        </EvaluationProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
  );
};

export default App;
